import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import eidfest1 from "../assets/eidfest (1).png";
import eidfest2 from "../assets/eidfest (2).png";
import eidfest3 from "../assets/eidfest (3).png";
import eidfest4 from "../assets/eidfest (4).png";
import eidfest6 from "../assets/eidfest (6).png";
import eidfest7 from "../assets/eidfest (7).png";
import eidfest8 from "../assets/eidfest (8).png";
import eidfest10 from "../assets/eidfest (10).png";
import eidfest11 from "../assets/eidfest (11).png";
import eidfest12 from "../assets/eidfest (12).png";
import eidfest13 from "../assets/eidfest (13).png";
import eidfest15 from "../assets/eidfest (15).png";
import eidgifts1 from "../assets/eidgifts (1).jpeg";
import eidgifts2 from "../assets/eidgifts (2).jpeg";
import eidgifts3 from "../assets/eidgifts (3).jpeg";
import henna1 from "../assets/henna (1).jpeg";
import henna2 from "../assets/henna (2).jpeg";
import EidAlFitrImg from "../assets/EidAlFitrImg.jpg";

const EidFestImages = [
  eidfest1, eidfest2, eidfest3, eidfest4,
  eidfest6, eidfest7, eidfest8, eidfest10,
  eidfest11, eidfest12, eidfest13, eidfest15,
];

const EidGifts = [eidgifts1, eidgifts2, eidgifts3];
const HennaImages = [henna1, henna2];

export const MobileEidAlFitr = () => {
  return (
    <div style={{ backgroundColor: "#f4f4f4" }}>
      <MobileNavigationBar />

      <div
        style={{
          position: "relative",
          backgroundImage: `url(${EidAlFitrImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "23vh",
          color: "white",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          }}
        />
        <Container
          className="d-flex flex-column justify-content-center align-items-center text-center"
          style={{ position: "relative", height: "100%" }}
        >
          <h2 className="display-4 fw-bold mt-2 pt-3">Ramadan & Eid</h2>
          <p className="lead mt-0 pb-1" style={{ fontSize: "14px" }}>
            At GAMRC (Greater Austin Muslim Relief Committee), we celebrate Eid by creating special Eid baskets for families,
            distributing Zakatul Fitr and Eid-al-Adha Qurbani, making goodie bags for kids, decorating hands with henna,
            annual Eid lunches, and supporting the community at the ATX Eid Fest.
          </p>
        </Container>
      </div>

      <Container className="mt-4">
        {/* Eid al-Fitr and Eid-al-Adha section */}
        <Row className="gx-3 text-start">
          <Col xs={12} className="mb-4" style={{ borderBottom: "2px solid #ccc", paddingBottom: "1rem" }}>
            <h4 className="fw-bold mb-2">Eid al-Fitr</h4>
            <ul style={{ paddingLeft: "1.2rem" }}>
              <li>GAMRC distributes Zakatul Fitr for the Greater Austin area.</li>
              <li>Food distribution is not possible due to lack of storage space and the inability to deliver to everyone in time.</li>
              <li>We provide gift cards for food and clothing, money for rent, and cash to bring happiness.</li>
              <li>The goal is to bring joy to those in need.</li>
              <li>Zakat is the right of the people — we do not decide what they eat. Food certificates allow families to buy the food they like and want.</li>
            </ul>
          </Col>

          <Col xs={12} className="mb-4">
            <h4 className="fw-bold mb-2">Eid-al-Adha</h4>
            <ul style={{ paddingLeft: "1.2rem" }}>
              <li>We distribute all Greater Austin Qurbani meat.</li>
              <li>There is a drop-off point or market for collection and organization.</li>
              <li>Our volunteers deliver meat to families in need on your behalf.</li>
              <li>We handle all organizing and distribution for you.</li>
              <li>Please follow the rules to make the process easier for everyone.</li>
              <li>Be respectful toward our volunteers and recipients.</li>
            </ul>
          </Col>
        </Row>
        <hr className="mb-5" style={{ height: '2px', backgroundColor: 'black' }} />
        <Row className="gx-3 text-center">
          {/* Gifts From The Heart */}
          <Col xs={12} className="mb-4">
            <div
              style={{
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
                aspectRatio: "4 / 3",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Carousel interval={30000}>
                {EidGifts.map((src, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={src}
                      alt={`Eid Gift ${idx + 1}`}
                      className="d-block mx-auto"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <h4 className="fw-bold mt-3">Gifts From The Heart</h4>
            <p style={{ maxWidth: "100%", margin: "0 auto", fontSize: "0.9rem" }}>
              Volunteers come together to pack and hand out festive baskets and goodie bags, spreading warmth,
              treats, and happiness to families in need across the community. GAMRC also distributes groceries to families in need during Ramadan.
            </p>
          </Col>

          {/* Painting Hands With Henna */}
          <Col xs={12} className="mb-4">
            <div
              style={{
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
                aspectRatio: "4 / 3",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Carousel interval={30000}>
                {HennaImages.map((src, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={src}
                      alt={`Henna ${idx + 1}`}
                      className="d-block mx-auto"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <h4 className="fw-bold mt-3">Painting Hands With Henna</h4>
            <p style={{ maxWidth: "100%", margin: "0 auto", fontSize: "0.9rem" }}>
              As part of Eid celebrations, volunteers decorate refugee girls' hands with henna the week before Eid.
            </p>
          </Col>

          {/* Festivities and Celebrations */}
          <Col xs={12} className="mb-4">
            <div
              style={{
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
                aspectRatio: "4 / 3",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <Carousel interval={30000}>
                {EidFestImages.map((src, idx) => (
                  <Carousel.Item key={idx}>
                    <img
                      src={src}
                      alt={`Eid Festival ${idx + 1}`}
                      className="d-block mx-auto"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <h4 className="fw-bold mt-3">Festivities and Celebrations</h4>
            <p style={{ maxWidth: "100%", margin: "0 auto", fontSize: "0.9rem" }}>
              GAMRC hosts an Eid lunch for the Quran students where they can enjoy food and celebrate together.
              GAMRC also supports the ATX Eid Fest, a city-wide community celebration organized by the Austin Muslim Community.
            </p>
          </Col>
        </Row>



      </Container>

      <MobileFooter />
    </div>
  );
};

export default MobileEidAlFitr;
